import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errorText } from "@/lib/api";
import { Logo } from "@/components/site/Navbar";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await login(email, password); nav("/admin"); } catch (ex) { setErr(errorText(ex)); } finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#EFF6FF] p-5">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-md rounded-[32px] bg-white p-8 shadow-[0_24px_60px_rgba(0,85,255,0.15)] sm:p-10">
        <Logo />
        <div className="mt-8 flex items-center gap-2 text-slate-500"><Lock className="h-4 w-4" /> <span className="text-sm font-bold uppercase tracking-[0.16em]">Admin login</span></div>
        <h1 className="mt-2 font-display text-3xl font-extrabold">Welcome back</h1>
        <label className="mt-8 block text-sm font-bold text-slate-700">Email
          <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full rounded-2xl border-2 border-slate-200 px-4 py-3 outline-none focus:border-[#0055FF]" />
        </label>
        <label className="mt-4 block text-sm font-bold text-slate-700">Password
          <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full rounded-2xl border-2 border-slate-200 px-4 py-3 outline-none focus:border-[#0055FF]" />
        </label>
        {err && <p data-testid="admin-login-error" role="alert" className="mt-4 rounded-xl bg-[#FFF1F2] px-4 py-3 text-sm font-medium text-[#BE123C]">{err}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-[#0055FF] py-4 font-bold text-white hover:bg-[#0043cc] disabled:opacity-70">
          {busy && <Loader2 className="h-5 w-5 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
